import { CompactSelection, GridSelection } from "@glideapps/glide-data-grid";

export const NON_DATA_COLUMN_ABBREVIATIONS = ["ENERGIETRÄGER", "GESAMT", "DATENGÜTE"] as const;

export const GRID_CELL_COLORS = {
  labelBg: "#efefef",
  scopeHeaderBg: "#d1d5db",
  sectionBg: "#f3f4f6",
  readOnlyBg: "#fafafa",
  mutedText: "#909090",
  activeText: "#000000",
} as const;

export const DEFAULT_GRID_SELECTION: GridSelection = {
  columns: CompactSelection.empty(),
  rows: CompactSelection.empty(),
  current: {
    cell: [1, 0],
    range: { x: 1, y: 0, width: 1, height: 1 },
    rangeStack: [],
  },
};
